var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"individual-layout"},[_c('IndividualInfoHeader'),_c('IndividualInfoTitle'),_c('IndividualInfoMonitorMap')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }